import { Card } from 'antd';
import React from 'react';

import { momentFormat } from '../../utils/common';

export const StartPopupContent = ({ t, point }) => {
  return (
    <Card bordered={false} bodyStyle={{ padding: 0, textAlign: 'left' }}>
      <strong>{point.formattedAddress || t('startLocation')}</strong>
      {point.journeyStartTs ? (
        <div>
          <strong>{t('startTime')}:</strong>{' '}
          {momentFormat(point.journeyStartTs, 'YYYY-MM-DD hh:mm a zz')}
        </div>
      ) : null}
    </Card>
  );
};
